// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import {
    BREAKPOINTS,
    down,
} from 'common/styles/breakpoints';

export const ButtonContainer = styled.span`
  margin-left: 5px;
`;

export const StatusContainer = styled.div<{ $withoutButton?: boolean }>`
    display: flex;
    align-items: flex-start;
`;

export const IconContainer = styled.div`
    margin-right: 8px;
    padding-top: 2px;

    line-height: 1;

    svg {
        width: 16px;
        height: 16px;
    }

    ${down(BREAKPOINTS.LG)} {
        margin-right: 0;
        cursor: pointer;
    }
`;

export const StatusLabelContainer = styled.div`
    font-size: 14px;
    line-height: 20px;

    ${down(BREAKPOINTS.LG)} {
        display: none;
    }
`;
